import React from "react";
import "./tutorSignin.css";
import {
  Col,
  Row,
  Typography,
  Form,
  Layout,
  Input,
  Button,
  Checkbox,
  Image,
} from "antd";
import { useNavigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { Post } from "../../config/api/post";
import { AUTH } from "../../config/constants/api";
import { addUser } from "../../redux/slice/authSlice";
import { FiMail, FiLock, FiVideo, FiLayers, FiAward } from "react-icons/fi";
import swal from "sweetalert";
import { ImageUrl } from "../../helpers/Functions";

function Signin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const userRole = useSelector((state) => state.user.userRole);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (user && token) {
      if (userRole === "ASSOCIATE") {
        navigate("/associate/dashboard", { replace: true });
      } else {
        navigate("/dashboard", { replace: true });
      }
    }
  }, [user, token, userRole, navigate]);

  const onFinish = (values) => {
    console.log("Success:", values);
    setLoading(true);

    let data = {
      email: values.email,
      password: values.password,
    };
    Post(AUTH.signin, data)
      .then((response) => {
        setLoading(false);
        if (response?.data?.status) {
          navigate("/dashboard", { replace: true });

          dispatch(
            addUser({
              user: response.data.data.user,
              token: response.data.data.token,
              role: "COACH",
            })
          );
          swal("Success", response.data.message, "success");
        } else {
          console.log("response", response);
          swal("Oops!", response.data.message, "error");
        }
      })
      .catch((e) => {
        console.log(":::;", e);
        setLoading(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Layout className="AuthBackground tutorSigninLayout" style={{ minHeight: "100vh" }}>
      <Row className="tutorSigninRow" gutter={[0, 0]}>
        <Col xs={24} lg={12} className="tutorSigninFormCol">
          <div className="tutorSigninFormShell">
            <div className="tutorSigninFormCard">
              <div className="tutorSigninCardGlow" aria-hidden />
              <Image
                src={ImageUrl("fav.png")}
                className="tutorSigninLogo"
                alt="WrightCo Academy"
                preview={false}
              />

              <Typography.Title level={2} className="fontFamily1 tutorSigninTitle">
                Trainer portal
              </Typography.Title>
              <Typography.Paragraph className="tutorSigninSubtitle">
                Log into WrightCo Academy to manage sessions, courses, and learners.
              </Typography.Paragraph>

              <div className="tutorSigninPills" aria-hidden>
                <span className="tutorSigninPill">Live lessons</span>
                <span className="tutorSigninPill">Assessments</span>
                <span className="tutorSigninPill">Schedule</span>
              </div>

              <Form
                layout="vertical"
                name="basic"
                className="loginForm tutorSigninForm"
                labelCol={{
                  span: 0,
                }}
                wrapperCol={{
                  span: 24,
                }}
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                <Form.Item
                  label="Email Address*"
                  name="email"
                  rules={[
                    {
                      type: "email",
                      message: "Please input valid email!",
                    },
                    {
                      required: true,
                      message: "Please input your email!",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="Enter Email Address"
                    className="tutorSigninInput"
                    prefix={<FiMail />}
                  />
                </Form.Item>

                <Form.Item
                  label={
                    <div className="tutorSigninPasswordLabelRow">
                      <span>Password*</span>
                      <button
                        type="button"
                        className="tutorSigninForgotButton"
                        onClick={() => navigate("/forgot-password")}
                      >
                        Forgot Password?
                      </button>
                    </div>
                  }
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your password!",
                    },
                  ]}
                >
                  <Input.Password
                    size="large"
                    prefix={<FiLock />}
                    placeholder="Enter Password"
                    className="tutorSigninInput"
                  />
                </Form.Item>

                <Form.Item
                  name="remember"
                  valuePropName="checked"
                  style={{ marginBottom: 16 }}
                >
                  <Checkbox className="tutorSigninRememberCheckbox">
                    <span className="fontFamily1">Remember Me</span>
                  </Checkbox>
                </Form.Item>

                <Form.Item style={{ marginBottom: 20 }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="loginButton tutorSigninSubmit"
                    block
                  >
                    {loading ? "Loading..." : "Login"}
                  </Button>
                </Form.Item>
              </Form>

              <Typography.Text className="tutorSigninFooterText fontFamily1">
                Not a User?{" "}
                <span
                  className="tutorSigninRegisterLink"
                  onClick={() => navigate("/signup")}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      navigate("/signup");
                    }
                  }}
                >
                  Register Now
                </span>
              </Typography.Text>

              <Typography.Text
                className="tutorSigninFooterText fontFamily1"
                style={{ display: "block", marginTop: 12 }}
              >
                Training associate?{" "}
                <span
                  className="tutorSigninRegisterLink"
                  role="button"
                  tabIndex={0}
                  onClick={() => navigate("/associate/signin")}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      navigate("/associate/signin");
                    }
                  }}
                >
                  Login as Associate
                </span>
              </Typography.Text>
            </div>
          </div>
        </Col>

        <Col xs={0} lg={12} className="tutorSigninPromoCol">
          <div className="tutorSigninPromoBg" aria-hidden />
          <div className="tutorSigninPromoContent">
            <Image
              src={ImageUrl("fav.png")}
              className="tutorSigninPromoLogo"
              alt="WrightCo Academy"
              preview={false}
            />
            <Typography.Title level={2} className="tutorSigninPromoTitle">
              Teach with clarity. Lead with confidence.
            </Typography.Title>
            <Typography.Paragraph className="tutorSigninPromoSubtitle">
              Your hub for meetings, course materials, assessments, and learner progress —
              designed around how trainers actually work.
            </Typography.Paragraph>

            <div className="tutorSigninFeatureGrid">
              <div className="tutorSigninFeature">
                <div className="tutorSigninFeatureIcon">
                  <FiVideo />
                </div>
                <span className="tutorSigninFeatureTitle">Live sessions</span>
                <span className="tutorSigninFeatureText">Run lessons and keep everyone on track.</span>
              </div>
              <div className="tutorSigninFeature">
                <div className="tutorSigninFeatureIcon">
                  <FiLayers />
                </div>
                <span className="tutorSigninFeatureTitle">Course tools</span>
                <span className="tutorSigninFeatureText">Organize content and structure your teaching flow.</span>
              </div>
              <div className="tutorSigninFeature">
                <div className="tutorSigninFeatureIcon">
                  <FiAward />
                </div>
                <span className="tutorSigninFeatureTitle">Outcomes</span>
                <span className="tutorSigninFeatureText">Review assessments and celebrate learner wins.</span>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Layout>
  );
}

export default Signin;
